// extracted by mini-css-extract-plugin
export default {"printApplication":"Summary_printApplication__-vGox","printButton":"Summary_printButton__C4v6U"};